import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

export type MilesAndMoreInfoProps = {
  miles: string;
};

export default function MilesAndMoreInfo({ miles }: MilesAndMoreInfoProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", sm: "center" },
        width: "100%"
      }}
    >
      <Typography
        sx={{
          fontFamily: "Neutraface2Demi",
          fontSize: { xs: 17, sm: 20 },
          lineHeight: 1.2
        }}
      >
        Miles & More
      </Typography>

      <Typography
        sx={{
          fontFamily: "Neutraface2Demi",
          fontSize: { xs: 14, sm: 16 },
          mt: 1,
          whiteSpace: "pre-line",
          lineHeight: 1.3
        }}
      >
        {t("transport.milesAndMoreCollect", { miles })}
      </Typography>
    </Box>
  );
}
